const s = "kioskTitle_a-m66", t = {
  kioskTitle: s
};
export {
  t as default,
  s as kioskTitle
};
//# sourceMappingURL=kioskTitle.module.scss.js.map
